import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import placeholder from 'lib/placeholder';

const GenericError = ({ message = placeholder('errors.couldNotLoad') }) => (
  <div className="flex flex-col items-center p-4">
    <Icon className="w-10" name="error-circle" size={null} />
    <Text className="mt-4 text-center" size="size2">
      {`${message} \nTente novamente em alguns minutos.`}
    </Text>
  </div>
);

GenericError.propTypes = {
  message: PropTypes.string,
};

export default GenericError;
